import { actions as authentication } from './profile/authentication'

export const resetStore = () => async (dispatch, getState) => {
  dispatch(authentication.reset())
};
